import {AnalyticsVisualizationAxisScale as AxisScale} from 'graphql-client/__generated/graphqlGlobalTypes';
import {AnalyticsVisualization} from 'insights/analytics-visualizations/__generated/AnalyticsVisualization';
import {VisualizationType} from 'insights/analytics-visualizations/AnalyticsVisualizationTypes';
import {RegressionType} from 'ui-library/charting/statistics/regression/RegressionTypes';

import getRegressionType from './getRegressionType';
import getVisualizationType from './getVisualizationType';

export default function updateVisualization(
  initialAnalyticsVisualization: AnalyticsVisualization,
  update: Partial<AnalyticsVisualization>
): AnalyticsVisualization {
  const newAnalyticsVisualization = {...initialAnalyticsVisualization, ...update};
  const visualizationType = getVisualizationType(newAnalyticsVisualization);
  const oldRegressionType = getRegressionType(initialAnalyticsVisualization);
  const newRegressionType = getRegressionType(newAnalyticsVisualization);
  if (
    visualizationType === VisualizationType.SCATTER_PLOT &&
    oldRegressionType !== newRegressionType &&
    newRegressionType === RegressionType.LOGISTIC
  ) {
    const parameters = {...newAnalyticsVisualization.parameters, xAxisScale: AxisScale.LOG};
    return {...newAnalyticsVisualization, parameters};
  }
  return newAnalyticsVisualization;
}
